import type { FunctionComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import { paletteHelper, Text } from '@property.com.au/ui-kit';
import { useLoadingViewContext } from '../../app-kit/contexts/LoadingViewContext/LoadingViewContext';

interface LoadingViewContentProps {
  loadingText?: string;
}
const slider = keyframes`
  0% {
    left: -10%;
  }
  100% {
    left: 110%;
  }
`;
export const LoadingBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 7px;
  width: 100%;
  background-color: transparent;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 30%;
    height: 5px;
    background: linear-gradient(
      90deg,
      rgb(101 87 255 / 0%) 0%,
      ${paletteHelper('textBrand')} 14.58%,
      ${paletteHelper('textBrand')} 86.48%,
      rgb(101 87 255 / 0%) 100%
    );
    animation: ${slider} 2s cubic-bezier(0.09, 0.89, 0.7, 0.71) infinite;
  }
`;

export const LoadingText = styled(Text).attrs(() => ({
  variant: 'title02',
}))`
  color: ${paletteHelper('textBrand')};
`;

const LoadingViewContentWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const LoadingViewContent: FunctionComponent<LoadingViewContentProps> = () => {
  const { loadingText } = useLoadingViewContext();

  return (
    <LoadingViewContentWrapper>
      <LoadingBar />
      {loadingText ? <LoadingText>{loadingText}</LoadingText> : null}
    </LoadingViewContentWrapper>
  );
};

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const LoadingViewWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* stylelint-disable plugin/no-unsupported-browser-features */
  @supports (width: 100svw) {
    width: 100svw;
    height: 100svh;
  }
  /* stylelint-enable plugin/no-unsupported-browser-features */
  z-index: 300;
  background-color: rgb(255 255 255 / 90%);
  animation: ${fadeIn} 0.3s;
`;

export const LoadingView: FunctionComponent = () => {
  const { isLoading, loadingText } = useLoadingViewContext();
  if (!isLoading) return null;

  return (
    <LoadingViewWrapper>
      <LoadingViewContent loadingText={loadingText} />
    </LoadingViewWrapper>
  );
};
